import { endpoints } from '../config'
import { getApiClient } from './api-client'
import mockUserInfo from './mockdata/mockdata-user.json'
import { EmployeeDataModelType } from '../common-types'
import { getBrowserCurrentTime } from '../utils'

export async function getMockUserInfo() {
  return mockUserInfo
}

/**
 * Fetches a RequesTix profile from the backend. Identity comes from the
 * Bearer token by default. When `impersonateEmail` is supplied (admin-only),
 * the backend loads that user's profile instead.
 */
export async function getUserInfo(impersonateEmail?: string) {
  const config = impersonateEmail ? { headers: { 'X-Impersonate-Email': impersonateEmail } } : {}
  return getApiClient({ endpoint: endpoints.userInfo, config })
}

export async function getUserAllocation({
  requesteeId = '',
  seasonDate = '',
  eventId = '',
  purposeType = '',
} = {}) {
  const params = {
    requestedForId: requesteeId,
    seasonDate,
    browserCurrentTime: getBrowserCurrentTime(),
    eventId,
    purposeType,
  }

  return getApiClient({ endpoint: endpoints.userAllocation, params })
}

export async function getEmployees({ searchName = '' }): Promise<EmployeeDataModelType[]> {
  const params = {
    searchName,
  }

  return getApiClient({ endpoint: endpoints.getEmployees, params })
}

export async function getEmployeeById({
  employeeId = '',
  eventId = '',
}): Promise<EmployeeDataModelType> {
  const params = {
    employeeId,
    eventId,
  }
  return getApiClient({ endpoint: endpoints.getEmployeeById, params })
}
